export default "__VITE_ASSET__B9VoTS6r__"